import React from 'react';
import { Partner } from '../../types/api';
import { getImageUrl } from '../../utils/image';

interface VenueCoverProps {
  partner: Partner | null;
  onEdit: () => void;
}

/**
 * Обложка заведения — единственная крупная плоскость в кабинете.
 *
 * Пока фото нет, вместо серого прямоугольника стоит штриховка с
 * размером кадра: партнёр должен понять, что здесь не пусто по ошибке,
 * а ждёт картинку, и какую.
 */
export const VenueCover: React.FC<VenueCoverProps> = ({ partner, onEdit }) => {
  // Обложка — отдельный широкий кадр (БП 5.2). Пока её не загрузили, шапку
  // рисует главное фото: оно квадратное и обрежется по центру, но лучше пустого
  // плейсхолдера.
  const coverSource = partner?.cover_image ?? partner?.main_image ?? null;
  const cover = coverSource ? getImageUrl(coverSource.url) || coverSource.url : null;
  // Статус публикации приходит с сервера (БП 5.4). Раньше плашка выводилась из
  // subscription.is_activated, а это другое: активация — про оплату и
  // готовность, публикация — про видимость и решение модератора.
  const publication = partner?.publication ?? null;

  const meta = [partner?.city?.name, partner?.address, partner?.primary_category?.title]
    .filter(Boolean)
    .join(' · ');

  return (
    <section className="qp-cover" aria-label="Обложка заведения">
      {cover ? (
        <div className="qp-cover-img" style={{ backgroundImage: `url(${cover})` }} />
      ) : (
        <div className="qp-cover-placeholder">ОБЛОЖКА 1600×420</div>
      )}
      <div className="qp-cover-scrim" />

      <div className="qp-cover-body">
        <div className="qp-cover-tags">
          <span
            className="qp-glass qp-glass--flat"
            title={publication?.reason ?? undefined}
          >
            {publication?.is_visible ? '● ' : '○ '}
            {(publication?.label ?? 'Черновик').toUpperCase()}
          </span>
          {partner?.id ? (
            <span className="qp-mono" style={{ fontSize: 11, color: 'rgba(255,255,255,.7)' }}>
              ID {partner.id}
            </span>
          ) : null}
        </div>
        <h1 className="qp-cover-title">{partner?.name || 'Заведение без названия'}</h1>
        {meta && <p className="qp-cover-meta">{meta}</p>}
        {/* Причина отказа — единственное, из-за чего партнёр пойдёт в поддержку;
            прятать её в тултип нельзя. */}
        {publication?.reason && <p className="qp-cover-meta">{publication.reason}</p>}
      </div>

      <div className="qp-cover-actions">
        <button type="button" className="qp-glass" onClick={onEdit}>
          {cover ? 'Заменить обложку' : 'Загрузить обложку'}
        </button>
      </div>
    </section>
  );
};
